export function JsGit(){

    return(

        <>
        <h1>Hello Git </h1>
        </>
    )
}

export default JsGit;